import React, { useState, useEffect } from "react";
import {
  Flex,
  Text,
  Button,
  Tooltip,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useDisclosure,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import axios from "axios";
import apiUrl from "variables/api";
import { FaListUl, FaUsers, FaStar, FaComments, FaPlus } from "react-icons/fa";
import AttendanceModal from "./components/AttendanceModal";
import { toast } from "react-toastify";

export default function Presence() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [scheduleData, setScheduleData] = useState([]);
  const [selectedTraining, setSelectedTraining] = useState(null);
  const [companyID, setCompanyID] = useState(null)


    const fetchCompanyData = async () => {
      try {
      const response = await axios
        .get(apiUrl + "/data/school/company/list", {
          headers: { "x-access-token": localStorage.getItem("token") },
        })
        return response.data.find((company) => company.active === 1) ? true : false;
      } catch (error) {
        console.error(error)
        return false;
      }
    };

    const fetchScheduleData = async () => {
      try {
        const response = await axios.get(apiUrl + "/data/school/company/schedule", {
          headers: { "x-access-token": localStorage.getItem("token") },
        });
        setCompanyID(response.data[0].companyID);
        setScheduleData(JSON.parse(response.data[0].trainings));
      } catch (error) {
        console.error(error);
      }
    }

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (await fetchCompanyData()) {
        if (isMounted) {
          await fetchScheduleData();
        }
      } else {
        toast.error("Nie znaleziono aktywnej kompanii");
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleOpenModal = (training, platoon, index) => {
    setSelectedTraining({ training, platoon, index });
    onOpen();
  };

  const [peoples, setPeoples] = useState([]);

  useEffect(() => {
    let isMounted = true;

    axios
      .get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (isMounted) {
          setPeoples(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });

    return () => {
      isMounted = false;
    };
  }, [apiUrl]);

  

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px" gap="3">
        <Flex gap="5" direction="column">
          <Text fontSize="xl" fontWeight="bold">
            Zarządzanie frekwencją
          </Text>
          <TableContainer>
            <Table size="sm" variant="simple">
              <Thead>
                <Tr>
                  <Th>Data</Th>
                  <Th>Nazwa szkolenia</Th>
                  <Th>Pluton 1</Th>
                  <Th>Pluton 2</Th>
                  <Th>Pluton 3</Th>
                </Tr>
              </Thead>
              <Tbody>
                {scheduleData.map((training, index) => (
                  <Tr key={index}>
                    <Td>{training.date}</Td>
                    <Td>{training.name}</Td>
                    <Td>
                      <Button colorScheme={training.attendanceChecked_1 ? "green" : "gray"} onClick={() => handleOpenModal(training, 1, index)} disabled={!training.platoon1}>
                        {training.platoon1 || "X"}
                      </Button>
                    </Td>
                    <Td>
                      <Button colorScheme={training.attendanceChecked_2 ? "green" : "gray"} onClick={() => handleOpenModal(training, 2, index)} disabled={!training.platoon2}>
                        {training.platoon2 || "X"}
                      </Button>
                    </Td>
                    <Td>
                      <Button colorScheme={training.attendanceChecked_3 ? "green" : "gray"} onClick={() => handleOpenModal(training, 3, index)} disabled={!training.platoon3}>
                        {training.platoon3 || "X"}
                      </Button>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Flex>
      </Card>
      {selectedTraining && (
        <AttendanceModal
          isOpen={isOpen}
          onClose={onClose}
          training={selectedTraining.training}
          platoon={selectedTraining.platoon}
          index={selectedTraining.index}
          companyID={companyID}
          peoples={peoples}
          fetchScheduleData={fetchScheduleData}
        />
      )}
    </Flex>
  );
}